/**
 * KM PDP lead consultation modal — opens <dialog>, validates honeypot + consent,
 * prepends structured product/variant meta to contact[body] before submit.
 */
(function () {
  var dialogSel = '[data-km-lead-dialog]';
  var openSel = '[data-km-lead-open]';
  var closeSel = '[data-km-lead-close]';

  function getVariantsData(root) {
    var el = root.querySelector('[data-km-lead-product-variants]');
    if (!el || !el.textContent) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function variantSummary(variants, variantId) {
    if (!variantId || !variants.length) return '';
    var id = String(variantId);
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === id) {
        var v = variants[i];
        return v.title + (v.sku ? ' (SKU: ' + v.sku + ')' : '');
      }
    }
    return 'Variant ID: ' + id;
  }

  function buildMeta(form) {
    var root = form.closest('[data-km-lead-root]');
    if (!root) root = document;
    var variants = getVariantsData(root);
    var productFormSel = root.getAttribute('data-km-lead-product-form');
    var productForm = productFormSel ? document.querySelector(productFormSel) : null;
    var variantInput = productForm ? productForm.querySelector('input[name="id"]') : null;
    var variantId = variantInput ? variantInput.value : '';

    var lines = [];
    lines.push('=== Consultation request (Kellermeister) ===');
    lines.push('Product: ' + (root.getAttribute('data-km-product-title') || '').trim());
    lines.push('URL: ' + (root.getAttribute('data-km-product-url') || '').trim());
    lines.push('Variant: ' + variantSummary(variants, variantId));
    var se = (root.getAttribute('data-km-supplier-email') || '').trim();
    lines.push('Supplier email (routing): ' + (se || '[not set — KM follow-up only]'));

    var companyEl = form.querySelector('[data-km-lead-company]');
    var company = companyEl ? companyEl.value : '';
    if (company && String(company).trim()) lines.push('Company: ' + String(company).trim());

    lines.push('Processing consent: yes');
    lines.push('');
    lines.push('--- Customer message ---');
    return lines.join('\n');
  }

  function onSubmit(ev) {
    var form = ev.target;
    if (!form.classList.contains('km-pdp-lead__form')) return;

    var honey = form.querySelector('[data-km-lead-honey]');
    if (honey && honey.value) {
      ev.preventDefault();
      return;
    }

    var consent = form.querySelector('[data-km-lead-consent]');
    if (consent && !consent.checked) {
      ev.preventDefault();
      consent.focus();
      return;
    }

    var body = form.querySelector('textarea[name="contact[body]"]');
    if (body) {
      var meta = buildMeta(form);
      var userMsg = (body.value || '').trim();
      body.value = meta + (userMsg ? '\n' + userMsg : '');
    }
  }

  function stripContactPostedFromUrl() {
    try {
      var u = new URL(window.location.href);
      if (!u.searchParams.has('contact_posted')) return;
      u.searchParams.delete('contact_posted');
      var q = u.searchParams.toString();
      history.replaceState({}, '', u.pathname + (q ? '?' + q : '') + u.hash);
    } catch (e) {}
  }

  function init() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest(openSel);
      if (!btn) return;
      var id = btn.getAttribute('aria-controls');
      if (!id) return;
      var dialog = document.getElementById(id);
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    });

    document.querySelectorAll(dialogSel).forEach(function (dialog) {
      var form = dialog.querySelector('.km-pdp-lead__form');
      if (form) form.addEventListener('submit', onSubmit);

      dialog.querySelectorAll(closeSel).forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (typeof dialog.close === 'function') dialog.close();
        });
      });

      var successEl = dialog.querySelector('[data-km-lead-success]');
      if (successEl && typeof dialog.showModal === 'function') {
        dialog.showModal();
        try {
          successEl.focus();
        } catch (e) {}
        // ?contact_posted=true keeps form.posted_successfully? true on every refresh; strip it after thanks.
        stripContactPostedFromUrl();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
